import { render, staticRenderFns } from "./pickadd.vue?vue&type=template&id=57feae83&scoped=true"
import script from "./pickadd.vue?vue&type=script&lang=js"
export * from "./pickadd.vue?vue&type=script&lang=js"
import style0 from "./pickadd.vue?vue&type=style&index=0&id=57feae83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57feae83",
  null
  
)

export default component.exports